export default __webpack_public_path__ + "static/media/facebook.b59bdcdb.svg";